// extracted by mini-css-extract-plugin
export default {"hr-desktop":"CtaHeader-module__hr-desktop__C_kQA","weight-heavy":"CtaHeader-module__weight-heavy__mmrq8"};